import { IFormularios } from "../../../../Interfaces/Geral/Formularios/FormulariosInterface";
import ListarResponderPesquisaSatisfacao from "./ListarResponderPesquisaSatisfacao";

export default function ResponderPesquisaSatisfacao(props: IFormularios) {
    return (
        <>
            <ListarResponderPesquisaSatisfacao
                idFormulario={props.ID_FORMULARIO}
            />
        </>
    );
}
